import {Suspense} from "react";
import {DefaultSkeletonPage} from "./Skeletons";

export default function WithSuspense({children, fallback=<DefaultSkeletonPage />}) {
    return (
        <Suspense fallback={fallback}>
            {children}
        </Suspense>
    )
}